/* eslint-disable import/extensions */
import CR_EN_SP1 from './creator/en/step-1.jsx';
import CR_EN_SP2 from './creator/en/step-2.png';
import CR_EN_SP3 from './creator/en/step-3.png';
import CR_EN_SP4 from './creator/en/step-4.png';
import CR_EN_SP5 from './creator/en/step-5.png';
import CR_EN_SP6 from './creator/en/step-6.png';
import CR_DE_SP1 from './creator/de/step-1.jsx';
import CR_DE_SP2 from './creator/de/step-2.png';
import CR_DE_SP3 from './creator/de/step-3.png';
import CR_DE_SP4 from './creator/de/step-4.png';
import CR_DE_SP5 from './creator/de/step-5.png';
import CR_DE_SP6 from './creator/de/step-6.png';
import AP_EN_SP1 from './approver/en/step-1.jsx';
import AP_EN_SP2 from './approver/en/step-2.png';
import AP_EN_SP3 from './approver/en/step-3.png';
import AP_EN_SP4 from './approver/en/step-4.png';
import AP_EN_SP5 from './approver/en/step-5.png';
import AP_EN_SP6 from './approver/en/step-6.png';
import AP_DE_SP1 from './approver/de/step-1.jsx';
import AP_DE_SP2 from './approver/de/step-2.png';
import AP_DE_SP3 from './approver/de/step-3.png';
import AP_DE_SP4 from './approver/de/step-4.png';
import AP_DE_SP5 from './approver/de/step-5.png';
import AP_DE_SP6 from './approver/de/step-6.png';

export const CR_EN_STEPS = {
  CR_EN_SP1: { type: 'component', content: CR_EN_SP1 },
  CR_EN_SP2: { type: 'image', content: CR_EN_SP2 },
  CR_EN_SP3: { type: 'image', content: CR_EN_SP3 },
  CR_EN_SP4: { type: 'image', content: CR_EN_SP4 },
  CR_EN_SP5: { type: 'image', content: CR_EN_SP5 },
  CR_EN_SP6: { type: 'image', content: CR_EN_SP6 },
};

export const CR_DE_STEPS = {
  CR_DE_SP1: { type: 'component', content: CR_DE_SP1 },
  CR_DE_SP2: { type: 'image', content: CR_DE_SP2 },
  CR_DE_SP3: { type: 'image', content: CR_DE_SP3 },
  CR_DE_SP4: { type: 'image', content: CR_DE_SP4 },
  CR_DE_SP5: { type: 'image', content: CR_DE_SP5 },
  CR_DE_SP6: { type: 'image', content: CR_DE_SP6 },
};

export const AP_EN_STEPS = {
  AP_EN_SP1: { type: 'component', content: AP_EN_SP1 },
  AP_EN_SP2: { type: 'image', content: AP_EN_SP2 },
  AP_EN_SP3: { type: 'image', content: AP_EN_SP3 },
  AP_EN_SP4: { type: 'image', content: AP_EN_SP4 },
  AP_EN_SP5: { type: 'image', content: AP_EN_SP5 },
  AP_EN_SP6: { type: 'image', content: AP_EN_SP6 },
};

export const AP_DE_STEPS = {
  AP_DE_SP1: { type: 'component', content: AP_DE_SP1 },
  AP_DE_SP2: { type: 'image', content: AP_DE_SP2 },
  AP_DE_SP3: { type: 'image', content: AP_DE_SP3 },
  AP_DE_SP4: { type: 'image', content: AP_DE_SP4 },
  AP_DE_SP5: { type: 'image', content: AP_DE_SP5 },
  AP_DE_SP6: { type: 'image', content: AP_DE_SP6 },
};
